<template>
  <div class="site-page">
    <div class="row">
      <div class="col-md-12 page-title">
        <h1>Ma consommation</h1>
        <p class="text-muted">
          Détails de la consommation des produits & services MTN et internet
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 order-md-first order-last">
        <ul class="nav nav-tabs v-step-0" id="consommation" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              :class="isActiveProducts == true ? 'active' : ''"
              id="products-tab"
              data-bs-toggle="tab"
              data-bs-target="#products"
              type="button"
              role="tab"
              aria-controls="products"
              aria-selected="true"
            >
              <div class="d-flex align-items-bottom">
                <span>Produits & services</span>
                <span
                  class="px-2"
                  id="tabs-spinner"
                  v-if="onloading_produits == true"
                >
                  <b-spinner></b-spinner>
                </span>
              </div>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              :class="isActiveProducts == false ? 'active' : ''"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
            >
              <div class="d-flex align-items-bottom">
                <span>Internet</span>
                <span
                  class="px-2"
                  id="tabs-spinner"
                  v-if="onloading_internet == true"
                >
                  <b-spinner></b-spinner>
                </span>
              </div>
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show"
            :class="isActiveProducts == true ? 'active' : ''"
            id="products"
            role="tabpanel"
            aria-labelledby="products-tab"
          >
            <div
              class="
                card-box
                d-flex
                align-items-center
                justify-content-center
                px-0
                mt-4
              "
              v-if="onloading_produits == false"
            >
              <div class="h-100 w-100">
                <div class="pt-3 pb-4 px-4 d-flex justify-content-end">
                  <button
                    v-if="
                      no_data_found_produits == false && error_produits == ''
                    "
                    class="
                      btn btn-primary
                      download
                      d-flex
                      align-items-center
                      py-2
                    "
                    @click="downloadPdf('produits')"
                  >
                    <b-spinner v-if="on_saving_products == true"></b-spinner>
                    <span v-else>Télécharger en PDF</span>
                  </button>
                </div>
                <div
                  class="text-center empty-box px-3"
                  v-if="no_data_found_produits == true"
                >
                  <i class="mdi mdi-alert-circle-check"></i>
                  <p>
                    <b>Aucune donnée de consommation pour cette période</b>
                  </p>
                </div>
                <div
                  class="text-center empty-box px-3"
                  v-if="
                    no_data_found_produits == false && error_produits !== ''
                  "
                >
                  <i class="mdi mdi-alert-circle"></i>
                  <p>
                    <b>{{ error_produits }}</b>
                  </p>
                </div>
                <div
                  class="bill-details-wrapper"
                  v-else-if="no_data_found_produits == false"
                >
                  <div class="py-4 fw-bold" id="last-update">
                    Dernière mise à jour le
                    <span class="text-capitalize">
                      {{
                        moment(this.getBiiling_Produits.lastUpdate).format(
                          "LLLL"
                        )
                      }}
                    </span>
                  </div>
                  <div
                    id="produits-services"
                    v-for="(line, index) in this.getBiiling_Produits.lines"
                    :key="index"
                  >
                    <div
                      class="
                        header-arr
                        line
                        w-100
                        d-flex
                        justify-content-center
                      "
                    >
                      {{ line.matched_date }}
                    </div>
                    <table
                      class="table table-striped bill-details-table"
                      id="table"
                    >
                      <thead class="thead-dark">
                        <tr>
                          <th class="w-20" scope="col">Service</th>
                          <th class="w-20" scope="col">Heure</th>
                          <th class="w-20" scope="col">Coût</th>
                          <th class="w-40" scope="col">Détails</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in line.datas" :key="index">
                          <td>{{ item.service }}</td>
                          <td>
                            {{ moment(item.record_time).format("hh:m:s") }}
                          </td>
                          <td>{{ item.cost }}</td>

                          <td>
                            <div v-if="item.b_number && item.duration !== '-'">
                              <div class="mb-1">
                                Destinataire: {{ item.b_number }}
                              </div>
                              <div>
                                <span>Durée:</span>
                                <span>{{ item.duration }}</span>
                              </div>
                            </div>
                            <div v-else>-</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                class="
                  card-box
                  d-flex
                  align-items-center
                  justify-content-center
                  mt-4
                  py-4
                "
                v-if="onloading_produits == true"
              >
                <div class="text-center">
                  <img src="@/assets/images/load.gif" style="height: 100px" />
                  <div>
                    <small class="text-center px-2">
                      L'affichage des details de consommation peut prendre
                      quelques secondes.
                      <br />Veuillez patienter SVP !
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="
                card-box
                d-flex
                align-items-center
                justify-content-center
                mt-4
                py-4
              "
              v-if="onloading_produits == true"
            >
              <div class="text-center">
                <img src="@/assets/images/load.gif" style="height: 100px" />
                <div>
                  <small class="text-center px-2">
                    L'affichage des details de consommation peut prendre
                    quelques secondes.
                    <br />Veuillez patienter SVP !
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            :class="isActiveProducts == false ? 'active show' : ''"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div
              class="
                card-box
                d-flex
                align-items-center
                justify-content-center
                px-0
                mt-4
                internet
              "
              v-if="onloading_internet == false"
            >
              <div class="h-100 w-100">
                <div class="pt-3 pb-4 px-4 d-flex justify-content-end">
                  <button
                    class="
                      btn btn-primary
                      download
                      d-flex
                      align-items-center
                      py-2
                      mb-3
                    "
                    @click="downloadPdf('internet')"
                    v-if="
                      no_data_found_internet == false && error_internet == ''
                    "
                  >
                    <b-spinner v-if="on_saving_internet == true"></b-spinner>
                    <span v-else>Télécharger en PDF</span>
                  </button>
                </div>
                <div
                  class="text-center empty-box px-3"
                  v-if="no_data_found_internet == true"
                >
                  <i class="mdi mdi-alert-circle-check"></i>
                  <p>
                    <b>Aucune donnée de consommation pour cette période</b>
                  </p>
                </div>
                <div
                  class="text-center empty-box px-3"
                  v-if="
                    no_data_found_internet == false && error_internet !== ''
                  "
                >
                  <i class="mdi mdi-alert-circle"></i>
                  <p>
                    <b>{{ error_internet }}</b>
                  </p>
                </div>
                <div
                  class="bill-details-wrapper"
                  v-else-if="no_data_found_internet == false"
                >
                  <div
                    class="header-arr line w-100 d-flex justify-content-center"
                  >
                    Total des consommations: {{ getBiiling_internet.mbtotal }}
                  </div>
                  <table
                    class="table table-striped bill-details-table internet"
                  >
                    <thead class="thead-dark">
                      <tr>
                        <th>Services</th>
                        <th>Consommation</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in getBiiling_internet.lines"
                        :key="index"
                      >
                        <td
                          class="
                            service
                            d-flex
                            align-items-center
                            text-truncate
                          "
                        >
                          <img
                            class="icon"
                            :src="loadImage(item.service)"
                            alt
                          />
                          <span>{{ item.service }}</span>
                        </td>
                        <td>{{ item.consumption }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              class="
                card-box
                d-flex
                align-items-center
                justify-content-center
                mt-4
                py-4
              "
              v-if="onloading_internet == true"
            >
              <div class="text-center">
                <img src="@/assets/images/load.gif" style="height: 100px" />
                <div>
                  <small class="text-center px-2">
                    L'affichage des details de consommation peut prendre
                    quelques secondes.
                    <br />Veuillez patienter SVP !
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 order-md-last order-first position-relative">
        <div class="sidebar-card v-step-1">
          <h3>Sélectionnez une période</h3>
          <div class="d-flex flex-wrap">
            <a
              type="button"
              class="btn btn-outline-secondary mb-2 mr-2 filter"
              @click="filterReq(filters.today)"
              :class="
                $store.state.core.current_filter.label == filters.today.label
                  ? 'active-filter'
                  : ''
              "
              >Aujourd'hui</a
            >
            <a
              type="button"
              class="btn btn-outline-secondary mb-2 mr-2"
              @click="filterReq(filters.yesterday)"
              :class="
                $store.state.core.current_filter.label ==
                filters.yesterday.label
                  ? 'active-filter'
                  : ''
              "
              >Hier</a
            >
            <a
              @click="
                getListOfConsommationsProduits(filters.week),
                  getListOfConsommationsInternet(filters.week)
              "
              type="button"
              class="btn btn-outline-secondary mb-2 mr-2 filter"
              :class="
                $store.state.core.current_filter.label == filters.week.label
                  ? 'active-filter'
                  : ''
              "
              >7 derniers jours</a
            >
            <a
              class="btn btn-outline-secondary mb-2 mr-2 filter"
              @click="filterReq(filters.last_month)"
              :class="
                $store.state.core.current_filter.label ==
                filters.last_month.label
                  ? 'active-filter'
                  : ''
              "
              >Ce mois</a
            >
          </div>
          <h3 class="mt-3">Définir une période</h3>
          <div>
            <div>
              <b-form-datepicker
                class="mb-2"
                placeholder="Date de début"
                locale="fr"
                v-model="custum_range_start"
              ></b-form-datepicker>
              <b-form-datepicker
                class="mb-2"
                placeholder="Date de fin"
                locale="fr"
                v-model="custum_range_end"
              ></b-form-datepicker>
              <b-button
                class="w-100 filter"
                variant="primary"
                :disabled="filters.custum_range.start.trim() == ''"
                @click="filterReq(filters.custum_range)"
                >Rechercher</b-button
              >
            </div>
          </div>
        </div>
        <div
          class="overlay mb-4"
          v-if="onloading_produits == true || onloading_internet == true"
        ></div>
        <div class="sidebar-card v-step-2">
          <h3>Alerte email</h3>
          <div class="w-100 d-flex justify-content-between mb-3">
            <span class="text-muted notif-text mr-2"
              >Recevoir les alertes des produits & services:</span
            >
            <b-form-checkbox
              switch
              v-model="
                $store.state.core.first_login_configs
                  .subscribed_conso_products_notif
              "
              size="lg"
              @change="changeEmailAlertStatus('produits')"
            ></b-form-checkbox>
          </div>
          <div class="w-100 d-flex justify-content-between">
            <span class="text-muted notif-text mr-2"
              >Recevoir les alertes internet:</span
            >
            <b-form-checkbox
              switch
              v-model="
                $store.state.core.first_login_configs
                  .subscribed_conso_internet_notif
              "
              size="lg"
              @change="changeEmailAlertStatus('internet')"
            ></b-form-checkbox>
          </div>
        </div>
      </div>
    </div>
    <v-tour
      name="consumption-tour"
      :steps="steps"
      :options="tour_options"
      :callbacks="myCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import _ from "lodash";
import { subscriber } from "@/services/";
// import ProduitsPDF from "@/components/pdf/produitsPDF.vue";
// import InternetPDF from "@/components/pdf/internetPDF";
export default {
  // components: { ProduitsPDF, InternetPDF },
  name: "Consumption",
  data: function () {
    return {
      tour_options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Passer",
          buttonPrevious: "Précédent",
          buttonNext: "Suivant",
          buttonStop: "Terminer",
        },
      },
      checked_notifs: true,
      onloading_produits: false,
      no_data_found_produits: false,
      onloading_internet: false,
      no_data_found_internet: false,
      error_produits: "",
      error_internet: "",
      custum_range_start: "",
      custum_range_end: "",
      filters: {
        today: {
          start: this.moment().format("YYYYMMDD"),
          end: this.moment().format("YYYYMMDD"),
          label: "today",
        },
        yesterday: {
          start: this.moment().subtract(1, "days").format("YYYYMMDD"),
          end: this.moment().subtract(1, "days").format("YYYYMMDD"),
          label: "yesterday",
        },
        week: {
          start: this.moment().subtract(7, "days").format("YYYYMMDD"),
          end: this.moment().format("YYYYMMDD"),
          label: "week",
        },
        last_month: {
          start: this.moment().clone().startOf("month").format("YYYYMMDD"),
          end: this.moment().clone().endOf("month").format("YYYYMMDD"),
          label: "last_month",
        },
        custum_range: {
          start: "",
          end: "",
          label: "custum_range",
        },
      },
      on_saving_products: false,
      on_saving_internet: false,
      guided_tour: "",
      steps: [],
      myCallbacks: {
        onPreviousStep: this.myCustomPreviousStepCallback,
        onNextStep: this.myCustomNextStepCallback,
        onFinish: this.onFinish,
        onSkip: this.onSkip,
      },
      isActiveProducts: true,
    };
  },
  async created() {
    this.guided_tour =
      this.$store.state.core.first_login_configs.already_guided;
    if (this.guided_tour == false) {
      this.steps = this.$store.state.configs.guided_tour.consumption.steps;
      this.steps = this.steps.map((element, index) => {
        return {
          target: `.v-step-${index}`,
          content: element.content,
          params: {
            placement: "top",
          },
        };
      });
    }
    if (
      _.isUndefined(this.$store.state.core.consommations.lines) ||
      _.isNull(this.$store.state.core.consommations.lines)
    ) {
      this.$store.state.core.current_filter = this.filters.week;
      this.getListOfConsommationsProduits(
        this.$store.state.core.current_filter
      );
    } else if (this.$store.state.core.consommations.lines.length <= 0) {
      this.no_data_found_produits = true;
    }
    if (
      _.isUndefined(this.$store.state.core.consommations_internet.lines) ||
      _.isNull(this.$store.state.core.consommations_internet.lines)
    ) {
      this.$store.state.core.current_filter = this.filters.week;
      this.getListOfConsommationsInternet(
        this.$store.state.core.current_filter
      );
    } else if (this.$store.state.core.consommations_internet.length <= 0) {
      this.no_data_found_internet = true;
    }
  },
  mounted: function () {
    if (this.steps.length > 0 && this.guided_tour == false) {
      this.$tours["consumption-tour"].start();
    }
  },
  methods: {
    async filterReq(filter) {
      this.getListOfConsommationsInternet(filter);
      this.getListOfConsommationsProduits(filter);
    },
    async getListOfConsommationsProduits(filter) {
      if (this.isNotMobileScreen == false) {
        const element = document.getElementById("consommation");
        if (element !== null && element !== undefined) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
      }
      this.onloading_produits = true;
      this.$store.state.core.current_filter = filter;
      try {
        await subscriber.get_bill_details(filter).then((response) => {
          this.onloading_produits = false;
          if (response.error || response.internal_error) {
            this.error_produits = response.error || response.internal_error;
            this.onloading_produits = false;
          } else if (response.lines && response.lines.length == 0) {
            this.no_data_found_produits = true;
            this.onloading_produits = false;
          } else {
            this.onloading_produits = false;
            this.no_data_found_produits = false;
          }
        });
      } catch (error) {
        this.onloading_produits = false;
        this.no_data_found_produits = true;
      }
    },
    async getListOfConsommationsInternet(filter) {
      if (this.isNotMobileScreen == false) {
        const element = document.getElementById("consommation");
        if (element !== null && element !== undefined) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
      }
      this.onloading_internet = true;
      this.$store.state.core.current_filter = filter;
      try {
        await subscriber.get_bill_internet_details(filter).then((response) => {
          this.onloading_internet = false;
          if (response.error || response.internal_error) {
            this.error_internet = response.error || response.internal_error;
            this.onloading_internet = false;
          } else if (
            !_.isUndefined(response.reponse.lines) &&
            response.reponse.lines.length > 0
          ) {
            this.no_data_found_internet = false;
            this.$store.state.core.consommations_internet = response.reponse;
          } else {
            this.no_data_found_internet = true;
          }
        });
      } catch (error) {
        this.onloading_internet = false;
        this.no_data_found_internet = true;
      }
      window.scrollTo({ bottom: 0, behavior: "smooth" });
    },
    loadImage(asset) {
      const matched = this.$store.state.configs.icons.find(
        (element) => element.icon.toLowerCase() === asset.toLowerCase()
      );
      if (matched !== undefined) {
        return `https://my.mtn.bj/aws/icons_s/${matched.url}`;
      } else {
        return `https://my.mtn.bj/aws/icons_s/unknown.png`;
      }
    },
    async downloadPdf(type) {
      if (this.on_saving_products == true && type == "produits") {
        return;
      }
      if (this.on_saving_internet == true && type == "internet") {
        return;
      }
      type == "produits"
        ? (this.on_saving_products = true)
        : (this.on_saving_internet = true);
      let data = {
        type: type,
        start: this.$store.state.core.current_filter.start,
        end: this.$store.state.core.current_filter.end,
      };
      try {
        await subscriber.downloader(data).then((response) => {
          if (response.success) {
            const link = document.createElement("a");
            link.href = `https://my.mtn.bj/aws/${response.filename}`;
            link.target = "_blank";
            link.setAttribute("download", `consommation-${type}.pdf`);
            link.click();
          }
          this.on_saving_products = false;
          this.on_saving_internet = false;
        });
      } catch (error) {
        this.on_saving_products = false;
        this.on_saving_internet = false;
      }
    },
    async changeEmailAlertStatus(type) {
      if (type == "produits") {
        if (
          confirm(
            `Voulez vous vraiment ${
              this.$store.state.core.first_login_configs
                .subscribed_conso_products_notif == true
                ? "activer"
                : "désactiver"
            } l'abonnement aux notifications des produits et services par email ?`
          )
        ) {
          await subscriber
            .notifications_subscription(
              type,
              this.$store.state.core.first_login_configs
                .subscribed_conso_products_notif
            )
            .then((response) => {
              if (response.error || response.internal_error) {
                this.$store.state.core.first_login_configs.subscribed_conso_products_notif =
                  !this.$store.state.core.first_login_configs
                    .subscribed_conso_products_notif;
              }
            });
        } else {
          this.$store.state.core.first_login_configs.subscribed_conso_products_notif =
            !this.$store.state.core.first_login_configs
              .subscribed_conso_products_notif;
        }
      } else if (type == "internet") {
        if (
          confirm(
            `Voulez vous vraiment ${
              this.$store.state.core.first_login_configs
                .subscribed_conso_internet_notif == true
                ? "activer"
                : "désactiver"
            } l'abonnement aux notifications internet par email ?`
          )
        ) {
          await subscriber
            .notifications_subscription(
              type,
              this.$store.state.core.first_login_configs
                .subscribed_conso_internet_notif
            )
            .then((response) => {
              if (response.error || response.internal_error) {
                this.$store.state.core.first_login_configs.subscribed_conso_internet_notif =
                  !this.$store.state.core.first_login_configs
                    .subscribed_conso_internet_notif;
              }
            });
        } else {
          this.$store.state.core.first_login_configs.subscribed_conso_internet_notif =
            !this.$store.state.core.first_login_configs
              .subscribed_conso_internet_notif;
        }
      }
    },
    myCustomPreviousStepCallback(currentStep) {},
    myCustomNextStepCallback(currentStep) {},
    async onFinish() {
      await subscriber.finishTour();
    },
    async onSkip() {
      await subscriber.finishTour();
    },
  },
  computed: {
    isNotMobileScreen() {
      if (window.screen.availWidth >= 600) {
        return true;
      } else {
        return false;
      }
    },
    getBiiling_Produits() {
      if (
        !_.isUndefined(this.$store.state.core.consommations) &&
        !_.isNull(this.$store.state.core.consommations)
      ) {
        if (
          !_.isUndefined(this.$store.state.core.consommations.lines) &&
          !_.isNull(this.$store.state.core.consommations.lines)
        )
          return this.$store.state.core.consommations;
      } else {
        return {};
      }
    },
    getBiiling_internet() {
      if (
        !_.isUndefined(this.$store.state.core.consommations_internet) &&
        !_.isNull(this.$store.state.core.consommations_internet)
      ) {
        if (
          !_.isUndefined(this.$store.state.core.consommations_internet) &&
          !_.isNull(this.$store.state.core.consommations_internet)
        )
          return this.$store.state.core.consommations_internet;
      } else {
        return {};
      }
    },
  },
  watch: {
    filters() {
      let start = this.moment(this.filters.custum_range.start).format(
        "YYYYMMDD"
      );
      let end = this.moment(this.filters.custum_range.end).format("YYYYMMDD")(
        (this.filters.custum_range.start = start.trim("-"))
      )((this.filters.custum_range.end = end.trim("-")));
    },
    custum_range_start() {
      let start = this.moment(this.custum_range_start).format("YYYYMMDD");
      let end = this.moment(this.custum_range_end).format("YYYYMMDD");
      if (this.custum_range_end == "") {
        end = start;
      }
      this.filters.custum_range.start = start.trim("-");
      this.filters.custum_range.end = end.trim("-");
    },
    custum_range_end() {
      let start = this.moment(this.custum_range_start).format("YYYYMMDD");
      let end = this.moment(this.custum_range_end).format("YYYYMMDD");
      this.filters.custum_range.start = start.trim("-");
      this.filters.custum_range.end = end.trim("-");
    },
    onloading_produits() {
      if (this.onloading_produits == false) {
        this.isActiveProducts = true;
      }
    },
    // onloading_internet() {
    //   if (this.onloading_internet == false) {
    //     this.isActiveProducts = false;
    //   }
    // },
  },
};
</script>
<style scoped lang="css">
.empty-box i {
  font-size: 62px;
  color: #dda129;
}
.card-box {
  min-height: 250px !important;
  margin-bottom: 60px !important;
  border: 1px solid #dee2e6 !important;
}
.active-filter {
  color: #fff;
  border-color: #95aac9;
  background-color: #95aac9;
}
.export-button {
  border-radius: 6px !important;
  padding: 6px 8px;
}
.table {
  display: table;
  border-collapse: collapse;
  width: 100% !important;
  font-size: 15px !important;
}
.table .tr {
  display: table-row;
}
.table:nth-last-of-type(odd) tr {
  border-bottom: 0px solid transparent !important;
}
.table .tr:first-child {
  font-weight: bold;
}
.table .tr .td {
  display: table-cell;
  padding: 8px;
}
.table .tr .td:first-child {
  border-left: 0;
}

.table-head {
  padding: 0.75rem !important;
  font-weight: 500;
  font-size: 15px !important;
}
.table-striped {
  background-color: rgba(0, 0, 0, 0.05) !important;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.cell {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.line {
  padding: 0.75rem;
}
.datas {
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}
::v-deep .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border: none !important;
  background: transparent !important;
}
::v-deep .nav-tabs .nav-link.active {
  /* color: #00678f !important; */
  color: #000000 !important;
  font-weight: 500 !important;
}
::v-deep .nav-tabs {
  border-bottom: 1px solid #dee2e6 !important;
  padding-bottom: 10px;
  padding-top: 10px;
}
::v-deep .nav-tabs .nav-link {
  border: none;
  color: #000;
  position: relative;
  padding-left: 0px;
  padding-right: 0px;
  margin-right: 40px;
  background: transparent !important;
}
.nav-tabs .nav-item {
  margin-right: 15px !important;
  margin-bottom: -1px !important;
}
::v-deep .nav-tabs .nav-link.active:after {
  content: "";
  position: absolute !important;
  left: 0;
  bottom: -10px;
  /* background: #00678f !important; */
  background: #000000 !important;
  height: 4px !important;
  width: 100% !important;
  transition: 0.3s !important;
}
.header-arr {
  background: #fc0 !important;
  padding: 10px 15px;
}
.table .thead-dark th {
  background-color: #343a40;
  border-color: #454d55;
  color: #ffffff !important;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
::v-deep .table-striped {
  background-color: rgba(0, 0, 0, 0.05) !important;
}
.table {
  background: #ffffff !important;
}
.icon {
  width: 28px !important;
  border-radius: 50% !important;
  margin-right: 4px !important;
}
.service {
  text-transform: capitalize !important;
}
#last-update {
  font-size: 14px !important;
  line-height: 120%;
  padding-left: 24px;
  padding-right: 24px;
  font-weight: 500 !important;
}
td {
  vertical-align: middle !important;
}
.w-20 {
  width: 20%;
}
.w-40 {
  width: 40%;
}
.overlay {
  position: absolute;
  top: 0;
  left: 15px;
  opacity: 0.2;
  height: calc(100% - 156px) !important;
  color: black;
  width: calc(100% - 30px) !important;
  background: #dee2e6;
  padding: 20px;
  border-radius: 12px;
  transition: 0.4s ease-out;
}
.notif-text {
  font-size: 14px !important;
}
::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #00bd5a !important;
  background-color: #00bd5a !important;
  cursor: pointer !important;
}
.download .spinner-border,
#tabs-spinner .spinner-border {
  width: 20px;
  height: 20px;
}
#tabs-spinner .spinner-border {
  color: #a8a8a8 !important;
  width: 16px !important;
  height: 16px !important;
}

@media (max-width: 576px) {
  .table {
    font-size: 12px !important;
  }
}
</style>
